import {Component, EventEmitter, Output} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent {

  @Output() agreed = new EventEmitter<void>();

  constructor(
    private modalService: NgbModal,
  ) {}


  dismiss() {
    this.modalService.dismissAll();
  }

  agreedClicked() {
    this.agreed.emit();
    this.dismiss();
  }

}
